import React from 'react';

import SkeletonListAllTabMobile from './SkeletonListAllTabMobile';
import * as Styled from './SkeletonListAllTabMobileStyles';

function SkeletonAllTabMobile() {
  const numberLinesRender = 4;

  function renderLines() {
    return Array.from({ length: numberLinesRender }, (_, index) => (
      <SkeletonListAllTabMobile
        key={`journeySkeletonListAllTabMobile-${index}`}
      />
    ));
  }

  return (
    <Styled.WrapperListAllTabMobile data-testid="loading-all-tab-Mobile">
      {renderLines()}
    </Styled.WrapperListAllTabMobile>
  );
}

export default SkeletonAllTabMobile;
